import { useNavigate } from "react-router-dom";
import useUser from "../../features/profile/useUser";
import { Fragment, useEffect } from "react";

const HexAuthWrapper = ({ children }) => {
  const { isAuthenticated: activeUser } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeUser) {
      return navigate("/");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!activeUser) return null;
  return <Fragment>{children}</Fragment>;
};

export default HexAuthWrapper;
